import { type BookingClient, type SchedulingEventType } from '../../../models/Scheduling'

export interface InvitationEmailInput {
  eventType: SchedulingEventType
  client?: BookingClient
  ownerName: string
  bookingUrl: string
}

export const invitationEmailText = ({ eventType, client, ownerName, bookingUrl }: InvitationEmailInput): string => {
  const firstName = client?.firstName ?? client?.email ?? 'there'
  return [
    "Subject: You're invited to book a meeting",
    '',
    `Hi ${firstName},`,
    '',
    `I'd love to schedule an ${eventType.name} with you (${eventType.durationMinutes} min). Pick a time that works for you.`,
    '',
    `Book your time: ${bookingUrl}`,
    '',
    'Feel free to reach out if you have any questions,',
    ownerName,
    'Financial Advisor',
  ].join('\n')
}
